import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { LeftBar } from './SideBar/LeftBar';
import Stack from '@mui/material/Stack';
import { NavBar } from './NavBar';
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {grey} from "@mui/material/colors";

export const Container = () => {

  const themeQuery = useTheme();
  const isMobile = useMediaQuery(themeQuery.breakpoints.down("lg"));

  return (
    <Stack
      sx={{
        flexDirection: isMobile ? 'column' : 'row',
        display: isMobile ? 'block' : '',
        height: '100%',
        background: themeQuery.palette.mode === 'dark' ? grey[700] : grey[100]
      }}
    >
      <LeftBar changePage={() => {}}/>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden',
          width: '100%',
        }}
      >
        {!isMobile && (
          <NavBar />
        )}
        <Outlet />
      </Box>
    </Stack>
    
    
  );
};
